<div class="edit-modal modal-fill-screen flex column">
  <ng-content></ng-content>
</div>
